import { memo } from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

import { I18n, Utils } from '../components';
import { useDispatch, useSelector } from 'react-redux';

import { getAssociatedEmployer } from '../../selectors/employers';
import { getCurrentUsersCase } from '../../selectors/cases';

const GreetingHeader = memo((props) => {
  const employer = useSelector(getAssociatedEmployer);
  const userProfile = useSelector((state) => state.entities.userProfile);
  const usersCase = useSelector(getCurrentUsersCase);

  const employerLogo = Utils.employerImagePath(employer?.employerId);

  if (__WEB__) {
    return (
      <View style={[styles.pageHeader, styles.pageHeaderPadding]}>
        <Image
          source={{ uri: employerLogo }}
          style={{
            width: 60,
            height: 60,
            borderWidth: 1,
            borderColor: COLOR.contrast,
            marginHorizontal: 10,
          }}
        />
        <View style={styles.textContainer}>
          <Text testID="goodDay" style={[styles.pageHeaderText]}>
            Good Day, {userProfile?.fullName}
          </Text>
          <Text style={styles.pageHeaderSubText}>{usersCase?.group}</Text>
        </View>
        {!!employer?.on_call && (
          <View style={[THEME.basicRow, { marginRight: 25 }]}>
            <Text style={styles.youAreOnCallText}>You are on-call</Text>
            <Image
              source={require('../../../resources/icon-pager-small.png')}
              style={styles.pagerIcon}
            />
          </View>
        )}
        {props.children}
      </View>
    );
  }
  return (
    <View style={[THEME.basicRow, styles.pageHeader, styles.pageHeaderPadding]}>
      <Image
        source={{ uri: employerLogo }}
        style={{
          width: 60,
          height: 60,
          borderWidth: 1,
          borderColor: COLOR.contrast,
          marginRight: 10,
        }}
      />
      <View style={styles.textContainer}>
        <Text style={[styles.pageHeaderText]}>Good Day, {userProfile?.fullName}</Text>
        <Text style={[styles.pageHeaderSubText, { marginTop: 5 }]}>{usersCase?.group}</Text>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  pageHeader: {
    backgroundColor: COLOR.altContrast,
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    borderBottomWidth: 1,
    borderBottomColor: 'rgb(228, 228, 228)',
  },
  pageHeaderPadding: {
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  pageHeaderText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: __WEB__ ? 26 : 20,
  },
  pageHeaderSubText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 14,
  },
  subText: {
    ...FONT.regular,
    fontSize: 12,
    color: COLOR.text,
    textAlign: 'center',
  },
  textContainer: {
    flex: 1,
  },
  youAreOnCallText: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 14,
    marginRight: 15,
  },
  pagerIcon: {
    width: 30,
    height: 21,
  },
});

export default GreetingHeader;
